/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

import {responseCallbackToTreeNodes} from '../../../+organizations/org-tree.service';
import {TreeNode} from '../../ui/tree-select/tree-select.component';

import {AbstractField} from './abstract-field';

/**
 * An tree widget to select a value from a tree
 */
@Component({
  selector: 'gp-form-field-entity',
  template: `
    <gp-tree-select
      [attr.test-id]="descriptor.zoneID"
      class="form-control"
      [url]="descriptor?.metadatas?.rel"
      [responseCallBack]="responseCallback"
      [isDefaultRecipient]="descriptor.zoneID === 'GP_WORKFLOW_FALLBACK_RECIPIENT'"
      [lazyValue]="value.transId"
      [formControl]="control"
      [(ngModel)]="value.value"
      (elementSelected)="onElementSelected($event)"
      [readOnly]="readOnly"
      [isSorted]="true"
      ngDefaultControl>
    </gp-tree-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityFieldComponent extends AbstractField implements OnInit {

  public ngOnInit() {
    if (this.descriptor.metadatas === null) {
      console.warn('Cannot build a tree field with no metadata', this);
      return;
    }
  }

  public onElementSelected(entity: any) {
    this.value.transId = entity.text;
  }

  public responseCallback(response: any, lookupMap: Map<any, any>, isDefaultRecipient?: boolean): TreeNode<any>[] {
    return responseCallbackToTreeNodes(response, lookupMap, isDefaultRecipient);
  }
}
